import { useMemo } from "react";
import { formatLocation, parseLocation } from "../utils";

/**
 * Returns the `data` collection for `DhlDropdown` component.
 * It makes sure the user selected value is always present in the list.
 *
 * @param {{ frequentPostalLocations: Array<ReturnType<typeof formatLocation>>, postalLocations: Array<ReturnType<typeof formatLocation>>, query: value, value: string}} props
 */
export const useData = ({
  frequentPostalLocations,
  postalLocations,
  query,
  value,
}) =>
  useMemo(() => {
    if (value === "{}") {
      return postalLocations.length > 0
        ? postalLocations
        : frequentPostalLocations;
    }

    const currentLocation = formatLocation(parseLocation(value));

    const filterCurrentLocation = (location) =>
      location.value !== currentLocation.value;

    if (query) {
      return [
        currentLocation,
        ...postalLocations.filter(filterCurrentLocation),
      ];
    }

    return [
      currentLocation,
      ...frequentPostalLocations.filter(filterCurrentLocation),
    ];
  }, [frequentPostalLocations, postalLocations, query, value]);
